import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';

type ReorderDirection = 'up' | 'down' | 'start' | 'end';
export interface ReorderMoveEvent {
  from: number;
  to: number;
}

@Component({
  selector: 'ag-reorder-context-menu',
  templateUrl: './reorder-context-menu.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ReorderContextMenuComponent {
  @Input() total = 0;
  @Input() removeLabel = 'Remove from List';
  @Input() showRemove = true;

  @Output() move = new EventEmitter<ReorderMoveEvent>();
  @Output() remove = new EventEmitter<number>();

  @ViewChild('template', { static: true }) template: TemplateRef<unknown>;

  index = 0;

  // CDK's CdkContextMenuTrigger caches its TemplatePortal per-trigger, so anything
  // passed via cdkContextMenuTriggerData is frozen at first open. Callers invoke
  // this from (cdkContextMenuOpened) so the latest index is read at open time.
  setIndex(index: number): void {
    this.index = index;
  }

  emitMove(direction: ReorderDirection): void {
    let to = this.index;
    switch (direction) {
      case 'up':
        to = this.index - 1;
        break;
      case 'down':
        to = this.index + 1;
        break;
      case 'start':
        to = 0;
        break;
      case 'end':
        to = this.total - 1;
        break;
    }
    this.move.emit({ from: this.index, to });
  }

  emitRemove(): void {
    this.remove.emit(this.index);
  }
}
